import { useMemo } from 'react';
import { Map } from 'immutable';
import { QueueKey } from 'flow/types/EntityKeys';
import {
    makeSelectOngoingQueueCalls,
    selectActiveCentionErrands,
    selectQueueHasOmniSupport,
    selectQueueIsOfTypeCentionOmni,
} from 'flow/selectors/queue-selectors';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import EmptyState from 'flow/pages/messages/EmptyState';

interface Props {
    queueKey: QueueKey;
}

const EmptyStateQueueItemsOngoing = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();

    const selectOngoingQueueCalls = useMemo(makeSelectOngoingQueueCalls, []);
    const ongoingQueueCalls = useAppSelector((state) =>
        selectOngoingQueueCalls(state, queueKey),
    );

    const queueIsOfTypeCentionOmni = useAppSelector((state) =>
        selectQueueIsOfTypeCentionOmni(state, queueKey),
    );

    const activeCentionErrands = useAppSelector((state) =>
        queueIsOfTypeCentionOmni
            ? selectActiveCentionErrands(state, queueKey)
            : Map(),
    );

    const queueHasOmniSupport = useAppSelector((state) =>
        selectQueueHasOmniSupport(state, queueKey),
    );

    if (ongoingQueueCalls.size || activeCentionErrands.size) return null;

    return (
        <EmptyState
            className="bg-gray-100!"
            message={
                queueHasOmniSupport
                    ? i18next.t('Queue.Omni.Section.Empty')
                    : i18next.t('Queue.QueueMembersInCall.Section.Empty')
            }
        />
    );
};

export default EmptyStateQueueItemsOngoing;
